/**
 * Hebrew detection + weight adjustment for Cmarkdown.
 *
 * A markdown block (paragraph, heading, list item, table cell, blockquote)
 * whose first *letter* is Hebrew is rendered right-to-left, and its font weight
 * is dropped by HEBREW_WEIGHT_REDUCTION so Hebrew glyphs — which read heavier
 * than Latin at the same numeric weight — sit visually balanced next to English.
 *
 * Detection keys off the first strong-directional letter, skipping leading
 * markdown markers, whitespace, digits, punctuation and emoji, so `**שלום**`,
 * `> שלום` and `1. שלום` all resolve as Hebrew. English-led lines (including
 * `Hello שלום`) stay left-to-right.
 */

// First letter (any script) in a string — used to find the leading "word"
// character while ignoring markers / whitespace / digits / punctuation / emoji.
const FIRST_LETTER_REGEX = /\p{L}/u;
// Hebrew script: the Hebrew block (U+0590–U+05FF) plus Hebrew presentation
// forms (U+FB1D–U+FB4F). Arabic and other RTL scripts are intentionally out.
const HEBREW_LETTER_REGEX = /\p{Script=Hebrew}/u;

// Weight units a Hebrew block drops relative to its English equivalent.
const HEBREW_WEIGHT_REDUCTION = 100;
// Lightest weight CSS accepts.
const MIN_FONT_WEIGHT = 100;

export function startsWithHebrew(text: string): boolean {
  const firstLetter = text.match(FIRST_LETTER_REGEX)?.[0];
  if (firstLetter == null) {
    return false;
  }

  return HEBREW_LETTER_REGEX.test(firstLetter);
}

export function adjustWeightForHebrew(weight: number): number {
  return Math.max(MIN_FONT_WEIGHT, weight - HEBREW_WEIGHT_REDUCTION);
}
